import { useCallback, useEffect } from "react";
import { useQuery } from "react-query";
import axios from "axios";

import { useClientId } from "../context/context";

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useClient() {
    const clientId = useClientId();
  
    const {
      data: client,
      error: clientError,
      isLoading: clientIsLoading,
    } = useQuery(["clientData", clientId], async () => {
        const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}`);
        return data}, {
          staleTime: 1000 * 60 * 30, // optional: cache for 5 minutes{
          refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
          cacheTime: 1000 * 60 * 60,  
      });
  
    const setColors = useCallback(() => {
      const colors = client?.colors;
      if (colors) {
        if (colors["--primary-color"]) {
          document.documentElement.style.setProperty("--primary-color", colors["--primary-color"]);
          document.documentElement.style.setProperty("--bs-primary", colors["--primary-color"]);
        }

        if (colors["--primary-font-color"]) {
          document.documentElement.style.setProperty("--primary-font-color", colors["--primary-font-color"]);
        }

        document.documentElement.style.removeProperty("--secondary-color");
      }
    }, [client]);

    const setHeaderInfo = useCallback(() => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = client.logo;
        document.title = client.companyName;
    }, [client])
  
    useEffect(() => {
      if (client) {
        setColors();
        setHeaderInfo();
      }
    }, [client, setColors, setHeaderInfo]);
  
    return { clientData: client, clientIsLoading, clientError };
  }
  
